export default __webpack_public_path__ + "img/fcf07cca29e56d7553cb98c3fdefa3ba.png";